import { FunctionComponent } from 'react'
import { ReactComponent as ThumbsUpIcon } from 'icons/thumbs-up-blue.svg'
import { ReactComponent as HeartIcon } from 'icons/heart-red.svg'
import { ReactComponent as ClapIcon } from 'icons/clap-green.svg'
import { Typography, Box } from '@material-ui/core'
//@ts-ignore
import { useTheme } from 'styled-components'
import styled from 'styled-components/macro'
import { useHistory } from 'react-router-dom'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'

const StyledReactionBox = styled(Box)`
  background-color: ${props => props.theme.colors.supplementary};
  border-radius: 50%;
  width: 3em;
  height: 3em;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-shadow: 0px 0px 9px #1B191B;

  && {
    @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
      width: 2.5em;
      height: 2.5em;
    }
  }
`

interface PostCardReactionsProps {
  userReactions: number[]
  setShowUserReactions: Function
  setActivePost: Function
  post: any
}

export const PostCardReactions: FunctionComponent<PostCardReactionsProps> = ({
  userReactions,
  setShowUserReactions,
  setActivePost,
  post
}) => {
  const theme = useTheme()
  const history = useHistory()
  const { isDevice } = useScreenSizes()

  return (
    <Box
      display="flex"
      mt="0.5em"
      onClick={() => {
        setActivePost(post)
        isDevice ? history.push(`/reactions/${post?.id}`) : setShowUserReactions(true)
      }}
      style={{ cursor: 'pointer' }}
    >
      {userReactions[0] > 0 && (
        <StyledReactionBox>
          <ThumbsUpIcon style={{ height: '1em', width: '1em', margin: '0 0.5em' }} />
          <Typography component="span" variant="caption">
            <Box fontWeight="bold" color={theme.colors.accent}>
              {userReactions[0]}
            </Box>
          </Typography>
        </StyledReactionBox>
      )}
      {userReactions[1] > 0 && (
        <StyledReactionBox ml="0.5em">
          <HeartIcon style={{ height: '1em', width: '1em', margin: '0 0.5em' }} />
          <Typography component="span" variant="caption">
            <Box fontWeight="bold" color={theme.colors.accent}>
              {userReactions[1]}
            </Box>
          </Typography>
        </StyledReactionBox>
      )}
      {userReactions[2] > 0 && (
        <StyledReactionBox ml="0.5em">
          <ClapIcon style={{ height: '1em', width: '1em', margin: '0 0.5em' }} />
          <Typography component="span" variant="caption">
            <Box fontWeight="bold" color={theme.colors.accent}>
              {userReactions[2]}
            </Box>
          </Typography>
        </StyledReactionBox>
      )}
    </Box>
  )
}
